import script from "./QuestionManager.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionManager.vue?vue&type=script&setup=true&lang=js"

import "./QuestionManager.vue?vue&type=style&index=0&id=1ee378fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee378fa"]])

export default __exports__